export default __webpack_public_path__ + "static/media/image-json-file.aa7c79df.svg";